import type { ITransformRT2, IVector2 } from '@seddi/math-v2';
import type { LogoTechnique } from '@seddi/scene';

export type MockupLogo = {
  id: string;
  imageSize: IVector2;
  imageSrc: string;
  imageOriginalSrc?: string;
  imageOriginalMD5?: string;
  isMockupAsset?: boolean;
  name: string;
  region: string;
  size: IVector2;
  technique: LogoTechnique;
  transform: ITransformRT2;
  recoloredImageSrc?: string;
  recoloredId?: string;
  colorPalette?: {
    originalColor: string;
    recoloredColor?: string;
    name?: string;
  }[];
  note?: string;
  isVector?: boolean;
  originalVectorSvg?: string;
  recoloredVectorSvg?: string;
  hasRasterContent?: boolean;
  rasterElements?: string[];
  displayName?: string;
  fileSize?: number;
  realWorldSize?: IVector2;
  hasMadeFullColor?: boolean;
  customTechnique?: string;
  pointOfMeasure?: string;
  pointOfMeasureLogoPoint?: string;
  pointOfMeasure2DName?: string;
  pointOfMeasure2DDistance?: IVector2;
};

export function normalizeRecoloredImageSrc(src: string | undefined): string | undefined {
  if (src == null) return undefined;
  return src.trim() === '' ? undefined : src;
}

export function normalizeMockupLogo(logo: MockupLogo): MockupLogo {
  const next = normalizeRecoloredImageSrc(logo.recoloredImageSrc);
  if (next === logo.recoloredImageSrc) return logo;
  return { ...logo, recoloredImageSrc: next };
}

export function normalizeMockupLogos(logos: readonly MockupLogo[]): MockupLogo[] {
  return logos.map(normalizeMockupLogo);
}

export function logoTextureImageSrc(
  logo: Pick<MockupLogo, 'recoloredImageSrc' | 'imageSrc'>,
): string {
  const r = normalizeRecoloredImageSrc(logo.recoloredImageSrc);
  return r ?? logo.imageSrc;
}
